import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { ChangePassEventType } from './change-pass.event.type';
import { ChangePass } from './model/change-pass';
import { TweenMax, Quint } from 'gsap';
import { SharedService } from '../../shared/shared.service';

@Component({
	selector: 'app-change-pass',
	templateUrl: './change-pass.component.html',
	styleUrls: ['./change-pass.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ChangePassComponent implements OnInit, OnDestroy {

	public form: FormGroup;
	public submited: boolean;
	public activeBackButton = false;
	public showStepButtons = false;
	public changePassData: ChangePass = new ChangePass();

	constructor(public sharedService: SharedService) { }

	ngOnInit() {
		TweenMax.delayedCall(.3, () => {
			this.show();
		});

		AppEventDispatcher.listen(ChangePassEventType.BUTTONS, () => {

			TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				});
			});

		});

		AppEventDispatcher.listen(ChangePassEventType.STEPS.CHANGE_PASS_WARNING, () => {
			this.showStepButtons = true;
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangePassEventType.BUTTONS);
		AppEventDispatcher.removeListener(ChangePassEventType.STEPS.CHANGE_PASS_WARNING);
	}

	show() {
		this.showStepButtons = false;
		AppEventDispatcher.dispatch(ChangePassEventType.STEPS.CHANGE_PASS_RESET_HOME, { show: true });
	}

	setForm(form: FormGroup) {
		this.form = form;
	}

	dispatchToResetPage(value: boolean) {
		AppEventDispatcher.dispatch(ChangePassEventType.STEPS.CHANGE_PASS_RESET, { show: true });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-pass/change-pass.component.ts